<div class="modal-header">
  <button type="button" aria-label="Close" class="btn-close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
      <div class="text-center fs-4 mt-3">QR Code เข้ากลุ่ม LINE OpenChat เพื่อติดตามข้อมูลข่าวสาร</div>
      <div class="col-12 mt-4 text-center mb-5">
        <img src="/assets/images/anounce-page-image/line_qr.png" alt="QR Code LINE" style="width: 60%;">
      </div>
</div>
